import { render } from "./activateAutomaticRenewal.vue?vue&type=template&id=7109a126&scoped=true"
import script from "./activateAutomaticRenewal.vue?vue&type=script&lang=ts"
export * from "./activateAutomaticRenewal.vue?vue&type=script&lang=ts"

import "./activateAutomaticRenewal.vue?vue&type=style&index=0&id=7109a126&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7109a126"

export default script